/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import withValidarPago from 'HOC/withValidarPago';
import withValidarRecuperar from 'HOC/withValidarRecuperar';
import { consumirServicioEncirptacion } from 'api';
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import classNames from 'classnames';
import BreadCrumb from 'components/BreadCrumbMex/BreadCrumb';
import BreadCrumbPasosV2 from 'components/BreadCrumbMex/BreadCrumbPasosV2';
import BreadCrumbSegukids from 'components/BreadCrumbMex/BreadCrumbSegukids';
import BreadCurmbPasos from 'components/BreadCrumbMex/BreadCrumbTipo2';
import { ContainerCheck } from 'components/InputsMex/extras';
import Page from 'components/Page';
import FormPago from 'components/Polizas/FormPago';
import { ALBERT_EVENTS } from 'constants/albert_events';
import {
  ambienteAplicacion,
  rechazoEncuesta,
  registroEncuesta,
  urlDescargarPDFGo4It,
  urlDonwloadVoucher,
  urlLinkEncuestas,
  urlPago,
  urlSeccionPago,
} from 'constants/urls';
import { CASUALITY_GENERAL } from 'containers/Casuality-General/constantes';
import { CASUALITY } from 'containers/Casuality/constantes';
import { LF } from 'containers/LineasFinancieras/Constantes/general';
import { SEGUKIDS } from 'containers/Segurykids/constants';
import { usePantallaPago } from 'contexts/FormPagoContext';
import { useNavbarContext } from 'contexts/NavbarContext';
import useAlbert from 'hooks/useAlbert';
import useCustomLocation from 'hooks/useCustomLocation';
import useCustomRouter from 'hooks/useCustomRouter';
import useCustomToast from 'hooks/useCustomToasts';
import useQueryParams from 'hooks/useQueryParams';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import { getQueryParams, mappRutasEmision } from 'utils/funciones';
import Loading from 'wrappers/Loading';

const ContainerPagoTBTA = ({ estadoGeneral }) => {
  const { idPoliza, codProducto, ingreso, banderaPrimerPagoCorreo } = useQueryParams();
  const history = useCustomRouter();
  const { addWarningToast, addErrorToast, addSuccessToast } = useCustomToast();

  const location = useCustomLocation();

  const methods = useForm({ mode: 'onChange' });

  const { dataUsuario } = useSelector((state) => state.datosUsuarios);

  const [isTarjetaSuscrita, setTarjetaSuscrita] = useState(false);

  const [isPagado, setPagado] = useState(false);

  const [newRoutes, setNewRoutes] = useState(null);

  const [loading, setLoading] = useState(true);

  const [emailContratante, setEmailContratante] = useState('');

  const [enviando, setEnviando] = useState(false);

  const [datosTarifacion, setDatosTarifacion] = useState(null);

  const [showCVV, setShowCVV] = useState(false);

  const [detallePago, setDetallePago] = useState({});

  const [pagoTradicional, setPagoTradicional] = useState(true);

  const [banderaPrimerPago, setBanderaPrimerPago] = useState(false);

  const [pagadoFormaTradicional, setPagadoFormaTradicional] = useState(false);

  const { setProductoActivo } = useNavbarContext();

  const [catalogo, setCatalogo] = useState({});

  const [urlComprobante, setUrlComprobante] = useState();

  const { addAutoEvent, AUTO_EVENTS, AUTO_OPERATIONS, addApEvent } = useAlbert();

  const permiteCambioJourney = useMemo(() => {
    const permisoUsuario =
      PRODUCTOS.APINDIVIDUAL !== codProducto &&
      (!dataUsuario?.userIsLoggedIn || dataUsuario?.usu_tipo_usuario === 'cliente');
    const productoPermitido = [
      PRODUCTOS.HOGAR,
      PRODUCTOS.LINEAS_FINANCIERAS,
      PRODUCTOS.HOGAR_FLEX,
      PRODUCTOS.HOGAR_DTC,
      PRODUCTOS.RCP,
      PRODUCTOS.CYBER,
      PRODUCTOS.PRESUSCRITOS,
      PRODUCTOS.MARINE_INLAND,
      PRODUCTOS.DO,
      PRODUCTOS.CASUALITY,
      PRODUCTOS.CASUALITY_GENERAL,
      PRODUCTOS.AUTO,
      PRODUCTOS.SEGUKIDS,
    ].includes(codProducto);
    return permisoUsuario || productoPermitido;
  }, []);

  const statePantalla = usePantallaPago();

  const verificarPrimerPago = (banderaPrimerPago) => {
    if (ingreso) {
      return setShowCVV(banderaPrimerPagoCorreo);
    }

    if (!dataUsuario?.userIsLoggedIn) {
      return setShowCVV(true);
    }

    if (dataUsuario?.usu_tipo_usuario === 'cliente') {
      return setShowCVV(true);
    }
    return setShowCVV(banderaPrimerPago);
  };

  const init = useCallback(async () => {
    setProductoActivo(codProducto);

    const Data = {
      ambiente: ambienteAplicacion,
      pasoPago: 'obtenerRedireccionamiento',
      polCodigo: idPoliza,
      usuCodigo: dataUsuario.cliCodigoCore,
      prodCodigo: codProducto,
      pasoEmision: 'listarTotales',
    };

    const res = await consumirServicioEncirptacion(urlSeccionPago, Data);

    console.log('RES: ', res);

    if (res.transaccion && res?.data) {
      const { catalogo, pago } = res?.data;

      setDatosTarifacion(catalogo.polValoresTotales);

      const {
        pasosRedireccionamiento,
        suscribioTarjeta,
        emailContratante: email,
        objDetallePago,
        redireccionar,
        realizoPagoTradicional,
        mensajeRedireccion,
        banderaPrimerPago: primerPago,
        pagoTradicional: banderaTradicionalPago,
      } = pago;

      setCatalogo({ ...catalogo, ...pago });

      if (redireccionar === false) {
        addWarningToast(mensajeRedireccion);
        return history.push('/');
      }

      setBanderaPrimerPago(primerPago);
      verificarPrimerPago(primerPago);
      setPagoTradicional(banderaTradicionalPago);
      setEmailContratante(email);
      codProducto !== PRODUCTOS.CASUALITY &&
        codProducto !== PRODUCTOS.CASUALITY_GENERAL &&
        codProducto !== PRODUCTOS.SEGUKIDS &&
        setNewRoutes(mappRutasEmision(pasosRedireccionamiento));
      setTarjetaSuscrita(suscribioTarjeta);
      setPagadoFormaTradicional(realizoPagoTradicional);
      if (objDetallePago) {
        setTarjetaSuscrita(false);
        setDetallePago(objDetallePago);
        setPagado(true);
      }
    } else {
      addWarningToast('Algo ha salido mal intenta nuevamente');
    }

    setLoading(false);
  }, [idPoliza]);

  const redirectToComplete = () => {
    const qParams = getQueryParams();
    if (!qParams?.completed) {
      const url = `${location.fullPathname}&completed=true`;
      history.replace(url);
    }
  };
  useEffect(() => {
    if (isTarjetaSuscrita || isPagado || pagadoFormaTradicional) {
      redirectToComplete();
    }
  }, [isTarjetaSuscrita, isPagado, pagadoFormaTradicional]);

  useEffect(() => {
    init();
  }, [init]);

  const generatePDF = async () => {
    if (codProducto !== PRODUCTOS.HOGAR_FLEX) return null;
    const { data } = await ApiKeyFetch.instance().post(urlDescargarPDFGo4It, {
      idPoliza,
      codProducto,
    });
    const { url: urlPDF } = data || {};
    return urlPDF || null;
  };

  const onSubmit = async (data) => {
    try {
      setEnviando(true);

      data.mesExpiracion = data.expiracion.split('/')[0];
      data.anioExpiracion = data.expiracion.split('/')[1];

      const Data = {
        datosPago: {
          ambiente: ambienteAplicacion,
          cotPasoCodigo: 'cargoRecurrente',
          polCodigo: idPoliza,
          ...data,
          idPlazo: datosTarifacion.idPlazo,
          formaPago: datosTarifacion.formaPago,
          realizarPago: showCVV,
          isFromLinkCobro: statePantalla.isFromLinkCobro,
        },
      };

      const res = await consumirServicioEncirptacion(urlPago, Data);
      console.log('RES: ', res);

      if (res?.transaccion === false && res?.errorType === 'validacion-continuar-pago') {
        addWarningToast(res?.message);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        return;
      }
      const go4ItUrl = await generatePDF();
      setCatalogo({
        ...catalogo,
        pendienteCompletar: res?.pago?.pendienteCompletar,
        nombrePoliza: res?.pago?.nombrePoliza,
        go4ItUrl: go4ItUrl || res?.pago?.go4ItUrl || undefined,
      });
      if (res.transaccion && res.pago && res.pago.isValid) {
        if (res?.pago?.detallePago) {
          if (`${res.pago.detallePago.ResultType}` === '1') {
            redirectToComplete();
            setDetallePago(res?.pago?.detallePago);
            setPagado(true);
            methods.reset({});
            if (PRODUCTOS.SEGUKIDS === codProducto) {
              donwload();
            }
            addSuccessToast(
              `Se envió un correo electrónico a ${emailContratante} con la información del pago`
            );
            addAlbertEvent(); // Agregar el evento de albert
            loadEncuesta();
          } else {
            addErrorToast(res?.pago?.detallePago?.errorDescripcion);
          }
        } else {
          console.log('SOLO SE SUSCRIBIO');
          setTarjetaSuscrita(true);
        }
      } else {
        addWarningToast(
          res?.pago?.errorDescription ||
            res?.errorDescripcion ||
            'Algo ha salido mal, verifica tus datos'
        );
      }
    } catch (error) {
      console.log(error);
    }
    setEnviando(false);
  };

  const onSubmitPagoTradicional = async () => {
    setEnviando(true);

    const Data = {
      datosPago: {
        ambiente: ambienteAplicacion,
        cotPasoCodigo: 'pagoTradicional',
        polCodigo: idPoliza,
        isFromLinkCobro: statePantalla.isFromLinkCobro,
      },
    };

    const res = await consumirServicioEncirptacion(urlPago, Data);

    if (res?.transaccion === false && res?.errorType === 'validacion-continuar-pago') {
      addWarningToast(res?.message);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      return;
    }
    const go4ItUrl = await generatePDF();
    setCatalogo({
      ...catalogo,
      pendienteCompletar: res?.pago?.pendienteCompletar,
      nombrePoliza: res?.pago?.nombrePoliza,
      go4ItUrl: go4ItUrl || undefined,
    });

    if (res?.transaccion) {
      if (PRODUCTOS.SEGUKIDS === codProducto) {
        donwload();
      }
      methods.reset({});
      setPagadoFormaTradicional(true);
      loadEncuesta();
    }
    setEnviando(false);
  };

  const onClickContinuar = async () => {
    console.log(newRoutes);
    if (ingreso) {
      const url = `/fin-compra?idPoliza=${idPoliza}&codProducto=${codProducto}`;
      history.replace('/listado-pre-polizas');
      history.push(url);
      return history.push(url);
    }

    history.push(newRoutes.suscripcion.goTo);
  };

  const addAlbertEvent = () => {
    const primaNeta = catalogo?.polValoresTotales?.primaTotal.replace(',', '');
    const payload = {
      albert_transaction_id: idPoliza,
      albert_value: primaNeta,
    };
    if (codProducto === PRODUCTOS.AUTO) {
      // Agregando evento Albert ----------------------------
      addAutoEvent(AUTO_OPERATIONS.albert_dtc_auto, AUTO_EVENTS.albert_purchase, payload);
      // Fin Agregando evento Albert ----------------------------
    }

    if (codProducto === PRODUCTOS.APINDIVIDUAL) {
      addApEvent(ALBERT_EVENTS.PURCHASE, payload);
    }
  };

  const onClickPrint = () => {
    window.print();
  };

  const donwload = async () => {
    const body = {
      empresa: 'AIGMEX',
      plataforma: 'WEB',
      idPoliza: idPoliza,
    };

    const res = await ApiKeyFetch.instance().post(urlDonwloadVoucher, body);
    if (res.transaccion === true) {
      setUrlComprobante(res.urlComprobante);
    }
  };

  //--------- Toast Encuesta-----------
  const myToastEncuestas = useRef(null);

  const closeToastEnceusta = () => {
    myToastEncuestas.current.clear();
  };

  const rechazarEncuesta = async () => {
    const res = await ApiKeyFetch.instance().post(rechazoEncuesta + idPoliza, {});
    if (res.transaccion === true) {
      closeToastEnceusta();
    }
  };

  const completeEncuesta = async () => {
    setLoading(true);
    const res = await ApiKeyFetch.instance().post(registroEncuesta + idPoliza + '&redirect=no', {});
    if (res.transaccion === true && res?.urlRedirecionarEncuesta !== '') {
      window.location.href = res?.urlRedirecionarEncuesta;
    }
  };

  const loadEncuesta = async () => {
    if (codProducto !== PRODUCTOS.APINDIVIDUAL) {
      const res = await ApiKeyFetch.instance().post(urlLinkEncuestas + idPoliza, {});
      if (res.transaccion === true) {
        myToastEncuestas.current.show({
          severity: 'info',
          sticky: true,
          content: (
            <div className="p-flex p-flex-column" style={{ flex: '1' }}>
              <div className="p-text-center" style={{ textAlign: 'center' }}>
                <i className="pi pi-question" style={{ fontSize: '3rem' }}></i>
                <h4>{res?.msgEncuesta}</h4>
                <p>{res?.msgEncuestaSub}</p>
              </div>
              <div className="row">
                <div className="col-6">
                  <Button
                    onClick={() => completeEncuesta()}
                    type="button"
                    label="Yes"
                    className="p-button-success w-100"
                  />
                </div>
                <div className="col-6">
                  <Button
                    onClick={() => rechazarEncuesta()}
                    type="button"
                    label="No"
                    className="p-button-secondary w-100"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-1"></div>
                <div className="col-10 my-2">
                  <Button
                    onClick={() => closeToastEnceusta()}
                    type="button"
                    label="Responder más tarde"
                    className="p-button-info w-100"
                  />
                </div>
                <div className="col-1"></div>
              </div>
            </div>
          ),
        });
      }
    }
  };
  //--------- Fin Toast Encuesta-----------
  return (
    <Loading loading={loading}>
      <Toast ref={myToastEncuestas} position="bottom-center" />
      <div className="cr-content mb-5 print-page">
        <Page>
          <BreadCrumb {...PASOS_BREADCRUMBS?.[codProducto]?.breadCrumb} />

          {[
            PRODUCTOS.pymesAbiertoInd,
            PRODUCTOS.PRESUSCRITOS,
            PRODUCTOS.HOGAR,
            PRODUCTOS.LINEAS_FINANCIERAS,
            PRODUCTOS.RCP,
            PRODUCTOS.CYBER,
            PRODUCTOS.HOGAR_DTC,
            PRODUCTOS.DO,
            PRODUCTOS.CASUALITY,
            PRODUCTOS.CASUALITY_GENERAL,
          ].includes(codProducto) &&
            newRoutes?.suscripcion?.itemBreadCrumb && (
              <BreadCrumbPasosV2
                {...PASOS_BREADCRUMBS?.[codProducto]?.breadCrumbPasosEmision?.[
                  newRoutes?.suscripcion?.itemBreadCrumb
                ]}
                styleimg={codProducto === PRODUCTOS.LINEAS_FINANCIERAS ? 'height200px mr-3' : ''}
                pasos={PASOS_BREADCRUMBS?.[codProducto]?.pasosEmision}
              />
            )}

          {[PRODUCTOS.APINDIVIDUAL, PRODUCTOS.CASUALITY].includes(codProducto) && (
            <BreadCrumbPasosV2
              {...PASOS_BREADCRUMBS?.[codProducto]?.breadCrumbPasosCotizacion?.[5]}
              pasos={PASOS_BREADCRUMBS?.[codProducto]?.pasosCotizacion}
            />
          )}
          {[PRODUCTOS.CASUALITY_GENERAL].includes(codProducto) && (
            <BreadCrumbPasosV2
              {...PASOS_BREADCRUMBS?.[codProducto]?.breadCrumbPasosCotizacion?.[6]}
              pasos={PASOS_BREADCRUMBS?.[codProducto]?.pasosCotizacion}
            />
          )}
          {![
            PRODUCTOS.pymesAbiertoInd,
            PRODUCTOS.PRESUSCRITOS,
            PRODUCTOS.HOGAR_DTC,
            PRODUCTOS.HOGAR,
            PRODUCTOS.HOGAR_FLEX,
            PRODUCTOS.APINDIVIDUAL,
            PRODUCTOS.LINEAS_FINANCIERAS,
            PRODUCTOS.RCP,
            PRODUCTOS.CYBER,
            PRODUCTOS.MARINE_INLAND,
            PRODUCTOS.DO,
            PRODUCTOS.CASUALITY,
            PRODUCTOS.CASUALITY_GENERAL,
            PRODUCTOS.SEGUKIDS,
          ].includes(codProducto) && (
            <BreadCurmbPasos {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasos[4]} />
          )}

          {PRODUCTOS.HOGAR_FLEX === codProducto && (
            <BreadCrumbPasosV2
              {...PASOS_BREADCRUMBS[PRODUCTOS.HOGAR_FLEX].breadCrumbPasosCotizacionHogarFlex[8]}
              pasos={PASOS_BREADCRUMBS[PRODUCTOS.HOGAR_FLEX].pasosHogarFlex}
            />
          )}
          {PRODUCTOS.MARINE_INLAND === codProducto && (
            <BreadCrumbPasosV2
              {...PASOS_BREADCRUMBS[PRODUCTOS.MARINE_INLAND].breadCrumbPasos[
                isTarjetaSuscrita || isPagado || pagadoFormaTradicional ? 8 : 7
              ]}
            />
          )}
          {PRODUCTOS.SEGUKIDS === codProducto && (
            <BreadCrumbSegukids
              {...PASOS_BREADCRUMBS[PRODUCTOS.SEGUKIDS].breadCrumbPasosSegukids[7]}
              pasos={PASOS_BREADCRUMBS[PRODUCTOS.SEGUKIDS]?.pasosContratante}
              showImg={false}
              showImgTitle={true}
              subtitleClassnames={'col-md-12 mx-0'}
              styleimg="p-5"
            />
          )}
          <div className={`${PRODUCTOS.SEGUKIDS === codProducto ? 'container' : ''}`}>
            <div className={`${PRODUCTOS.SEGUKIDS === codProducto ? 'row border mx-0' : ''}`}>
              <div className={`${PRODUCTOS.SEGUKIDS === codProducto ? 'col-md-12' : ''}`}>
                <FormProvider {...methods}>
                  <form onSubmit={methods.handleSubmit(onSubmit)}>
                    {!isTarjetaSuscrita && !isPagado && !pagadoFormaTradicional && (
                      <FormPago
                        idPoliza={idPoliza}
                        enviando={enviando}
                        catalogo={catalogo}
                        setTarjetaSuscrita={setTarjetaSuscrita}
                        emailContratante={emailContratante}
                        onClickContinuar={onClickContinuar}
                        datosTarifacion={datosTarifacion}
                        showCVV={showCVV}
                        codProducto={codProducto}
                        pagoTradicional={pagoTradicional}
                        banderaPrimerPago={banderaPrimerPago}
                        newRoutes={newRoutes}
                        estadoGeneral={estadoGeneral}
                      />
                    )}

                    {(isTarjetaSuscrita || isPagado || pagadoFormaTradicional) && (
                      <div className="row justify-content-center mt-2">
                        <div
                          className={`${
                            PRODUCTOS.SEGUKIDS === codProducto
                              ? 'col-md-12 col-xl-11 '
                              : 'col-11 col-xl-8 card-login-mex'
                          }`}
                        >
                          <div className="row justify-content-center mt-5">
                            <div className="col-md-6 text-center">
                              <ContainerCheck className="d-inline" hideCursor width={100}>
                                <input id="finish" type="checkbox" defaultChecked disabled />
                                <label htmlFor="finish" />
                              </ContainerCheck>
                            </div>

                            {isTarjetaSuscrita && (
                              <div className="col-12 text-center">
                                <h1 className="font-mex text-mex">¡Felicidades!</h1>
                                <h4 className="font-mex font-weight-light">
                                  Tu tarjeta ha sido registrada exitosamente
                                </h4>
                              </div>
                            )}

                            {pagadoFormaTradicional && (
                              <div className="col-12 text-center">
                                {PRODUCTOS.SEGUKIDS !== codProducto && (
                                  <h1 className="font-mex text-mex">¡Felicidades!</h1>
                                )}
                                {PRODUCTOS.SEGUKIDS === codProducto && (
                                  <h1 className="font-mex text-mex">
                                    ¡Felicidades!, muy pronto tus seres queridos estarán protegidos
                                    con AIG.
                                  </h1>
                                )}
                                {PRODUCTOS.SEGUKIDS !== codProducto && (
                                  <h4 className="font-mex font-weight-light">
                                    Has completado el proceso, para realizar el pago de forma
                                    referenciado.
                                  </h4>
                                )}
                                {PRODUCTOS.SEGUKIDS === codProducto && (
                                  <h4 className="font-mex font-weight-light">
                                    Has completado el proceso para realizar el pago por línea de
                                    captura.
                                  </h4>
                                )}
                              </div>
                            )}

                            {isPagado && (
                              <div className="col-12">
                                <div className="mx-3 mx-md-5">
                                  {PRODUCTOS.SEGUKIDS !== codProducto && (
                                    <h1 className="text-center text-mex">{detallePago.msgPago}</h1>
                                  )}
                                  {PRODUCTOS.SEGUKIDS === codProducto && (
                                    <div>
                                      <h1 className="text-center text-mex mb-0">
                                        {' '}
                                        ¡Felicidades, el pago se realizó exitosamente!
                                      </h1>
                                      <h1 className="text-center text-mex mt-0 mb-4">
                                        {' '}
                                        Ahora, tus seres queridos están protegidos con AIG.
                                      </h1>
                                    </div>
                                  )}
                                  <div
                                    className={`${
                                      PRODUCTOS.SEGUKIDS === codProducto
                                        ? 'col-md-6 offset-md-4'
                                        : ''
                                    }`}
                                  >
                                    <ItemDetalle
                                      label="Estado del pago:"
                                      value={detallePago?.estadoPagoLabel}
                                    />

                                    <ItemDetalle
                                      label="Referencia:"
                                      value={detallePago?.referencia}
                                    />

                                    <ItemDetalle
                                      label="Fecha del pago:"
                                      value={detallePago?.fechaPago}
                                    />

                                    <ItemDetalle
                                      label="Hora del pago:"
                                      value={detallePago?.horaPago}
                                    />

                                    <ItemDetalle
                                      label="Número de autorización:"
                                      value={detallePago?.nroAutorizacion}
                                    />

                                    <ItemDetalle
                                      label="Monto:"
                                      value={`$${detallePago.monto}${' '}${detallePago.moneda}`}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </form>
                  {permiteCambioJourney &&
                    !catalogo.pendienteCompletar &&
                    catalogo.nombrePoliza && (
                      <React.Fragment>
                        <div className="row justify-content-center text-center">
                          <div className="col-12">
                            <h5 className="font-mex font-20px">
                              El proceso de contratación de tu póliza ha finalizado. En breve
                              recibirás en el mail que registraste tu póliza.
                            </h5>
                            <h4 className="font-mex mt-2">Número de póliza</h4>
                            <h5 className="font-mex mb-3">{catalogo.nombrePoliza}</h5>
                            {codProducto === PRODUCTOS.HOGAR_FLEX && catalogo.go4ItUrl && (
                              <a
                                href={catalogo.go4ItUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-primary-400 btn-wrap link-donwload"
                                style={{ maxWidth: '25rem' }}
                              >
                                Consulta el reporte de opinión de valor de la vivienda
                              </a>
                            )}
                          </div>
                          {PRODUCTOS.SEGUKIDS === codProducto && (
                            <div>
                              <h3 className="text-mex">
                                Si necesitas de orientación en caso de dudas puedes comunicarte al
                                Centro de Atención a Clientes al teléfono:
                              </h3>
                              <h3 className="text-mex">
                                800 001 1300 o en la Ciudad de México y Zona Metropolitana al 55
                                5488 4700 en la opción 3.
                              </h3>
                              <h3 className="text-mex mb-0">
                                Lunes a Jueves de 8:00 a 17:30 horas.
                              </h3>
                              <h3 className="text-mex mt-0">Viernes de 8:00 a 16:00 horas. </h3>
                            </div>
                          )}
                        </div>
                      </React.Fragment>
                    )}

                  {(isTarjetaSuscrita || isPagado || pagadoFormaTradicional) && !ingreso && (
                    <div className="row justify-content-center my-5">
                      <div className="col-md-10 col-lg-8 col-xl-6">
                        <div className="row justify-content-center">
                          {!pagadoFormaTradicional &&
                            PRODUCTOS.SEGUKIDS === codProducto &&
                            !isTarjetaSuscrita && (
                              <div className="col-md-6">
                                <a
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href={urlComprobante}
                                  className="btn btn-primary-cyan link-donwload"
                                >
                                  Descargar comprobante
                                </a>
                              </div>
                            )}
                          {!pagadoFormaTradicional && PRODUCTOS.SEGUKIDS !== codProducto && (
                            <div className="col-md-6">
                              <button
                                className="btn btn-primary mx-3 btn-block"
                                type="button"
                                onClick={onClickPrint}
                              >
                                Descargar comprobante
                              </button>
                            </div>
                          )}
                          {!permiteCambioJourney && (
                            <div className="col-md-6">
                              <button
                                className="btn btn-primary mx-3 btn-block"
                                onClick={onClickContinuar}
                              >
                                AHORA VAMOS A EMITIR TU PÓLIZA
                              </button>
                            </div>
                          )}
                          {permiteCambioJourney && (
                            <div className="col-md-6">
                              <button
                                className="btn btn-primary mx-3 btn-block"
                                onClick={history.goTo('/')}
                              >
                                Volver al inicio
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {(isTarjetaSuscrita || isPagado) && ingreso && (
                    <div className="row justify-content-center ">
                      <div className="col-11 col-xl-8">
                        <div className="row justify-content-end">
                          <div className="col-11 col-md-6 col-lg-4 mt-3">
                            <button className="btn btn-primary px-3" onClick={onClickContinuar}>
                              CONTINUAR
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {methods.watch('tipoPago') === 'tradicional' && (
                    <div className="row justify-content-center ">
                      <div
                        className={`${
                          PRODUCTOS.SEGUKIDS === codProducto
                            ? 'col-sm-11 col-lg-10'
                            : 'col-11 col-xl-8'
                        }`}
                      >
                        <div
                          className={`${
                            PRODUCTOS.SEGUKIDS === codProducto
                              ? 'row justify-content-center'
                              : 'row justify-content-around'
                          }`}
                        >
                          <div
                            className={classNames('col-11 col-md-6 col-lg-4 mt-3', {
                              'd-none': ![
                                PRODUCTOS.HOGAR,
                                PRODUCTOS.HOGAR_DTC,
                                PRODUCTOS.HOGAR_FLEX,
                                PRODUCTOS.LINEAS_FINANCIERAS,
                                PRODUCTOS.RCP,
                                PRODUCTOS.CYBER,
                                PRODUCTOS.MARINE_INLAND,
                                PRODUCTOS.DO,
                                PRODUCTOS.CASUALITY,
                                PRODUCTOS.CASUALITY_GENERAL,
                                PRODUCTOS.AUTO,
                                PRODUCTOS.SEGUKIDS,
                              ].includes(codProducto),
                            })}
                          >
                            <button
                              className={`btn btn-primary btn-block ${
                                PRODUCTOS.SEGUKIDS === codProducto ? 'btn-segukids' : ''
                              }`}
                              type="button"
                              onClick={() => {
                                if (codProducto === PRODUCTOS.LINEAS_FINANCIERAS) {
                                  return history.push(`${LF.urls.vigencia}?idPoliza=${idPoliza}`);
                                }

                                if (codProducto === PRODUCTOS.CASUALITY) {
                                  return history.push(
                                    `${CASUALITY.urls.contratante}?id=${idPoliza}`
                                  );
                                }

                                if (codProducto === PRODUCTOS.CASUALITY_GENERAL) {
                                  return history.push(
                                    `${CASUALITY_GENERAL.urls.vigencia}?id=${idPoliza}`
                                  );
                                }
                                if (codProducto === PRODUCTOS.SEGUKIDS) {
                                  return history.push(
                                    `${SEGUKIDS.urls.asegurado}?idPoliza=${idPoliza}`
                                  );
                                }

                                return history.push(newRoutes.suscripcion.goBack);
                              }}
                              disabled={enviando}
                            >
                              {PRODUCTOS.SEGUKIDS === codProducto && (
                                <i
                                  className="pi pi-arrow-left"
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    fontSize: '1.4rem',
                                    paddingRight: '5px',
                                  }}
                                />
                              )}
                              ATRÁS
                            </button>
                          </div>
                          <div className="col-11 col-md-6 col-lg-4 mt-3">
                            <button
                              className={`btn btn-primary btn-block px-3 ${
                                PRODUCTOS.SEGUKIDS === codProducto ? 'btn-segukids' : ''
                              }`}
                              onClick={onSubmitPagoTradicional}
                              disabled={enviando || estadoGeneral?.bloquearPago}
                            >
                              {enviando ? 'PROCESANDO...' : 'CONTINUAR'}
                              {PRODUCTOS.SEGUKIDS === codProducto && (
                                <i
                                  className="pi pi-arrow-right"
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    fontSize: '1.4rem',
                                    paddingLeft: '5px',
                                  }}
                                />
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {!['tradicional', 'online'].includes(methods.watch('tipoPago')) &&
                    [
                      PRODUCTOS.HOGAR,
                      PRODUCTOS.HOGAR_DTC,
                      PRODUCTOS.HOGAR_FLEX,
                      PRODUCTOS.LINEAS_FINANCIERAS,
                      PRODUCTOS.RCP,
                      PRODUCTOS.CYBER,
                      PRODUCTOS.MARINE_INLAND,
                      PRODUCTOS.DO,
                      PRODUCTOS.CASUALITY,
                      PRODUCTOS.CASUALITY_GENERAL,
                      PRODUCTOS.AUTO,
                      PRODUCTOS.SEGUKIDS,
                    ].includes(codProducto) &&
                    !isTarjetaSuscrita &&
                    !pagadoFormaTradicional &&
                    !isPagado && (
                      <div className="row justify-content-around">
                        <div
                          className={`${
                            PRODUCTOS.SEGUKIDS === codProducto
                              ? 'col-sm-11 col-lg-10'
                              : 'col-11 col-xl-8'
                          }`}
                        >
                          <div className="row justify-content-center">
                            <div
                              className={`${
                                PRODUCTOS.SEGUKIDS === codProducto
                                  ? 'col-11 col-md-6 col-lg-4'
                                  : 'col-11 col-md-6'
                              }`}
                            >
                              <button
                                className={`btn btn-primary btn-block ${
                                  PRODUCTOS.SEGUKIDS === codProducto ? 'btn-segukids px-3' : ''
                                }`}
                                type="button"
                                onClick={() => {
                                  if (codProducto === PRODUCTOS.LINEAS_FINANCIERAS) {
                                    return history.push(`${LF.urls.vigencia}?idPoliza=${idPoliza}`);
                                  }

                                  if (codProducto === PRODUCTOS.CASUALITY) {
                                    return history.push(
                                      `${CASUALITY.urls.contratante}?id=${idPoliza}`
                                    );
                                  }
                                  if (codProducto === PRODUCTOS.CASUALITY_GENERAL) {
                                    return history.push(
                                      `${CASUALITY_GENERAL.urls.vigencia}?id=${idPoliza}`
                                    );
                                  }
                                  if (codProducto === PRODUCTOS.SEGUKIDS) {
                                    return history.push(
                                      `${SEGUKIDS.urls.asegurado}?idPoliza=${idPoliza}`
                                    );
                                  }
                                  console.log(newRoutes);
                                  return history.push(newRoutes.suscripcion.goBack);
                                }}
                              >
                                {PRODUCTOS.SEGUKIDS === codProducto && (
                                  <i
                                    className="pi pi-arrow-left"
                                    style={{
                                      position: 'relative',
                                      top: '1px',
                                      fontSize: '1.4rem',
                                      paddingRight: '5px',
                                    }}
                                  />
                                )}
                                ATRÁS
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                </FormProvider>
              </div>
            </div>
          </div>
        </Page>
      </div>
    </Loading>
  );
};

// export default withValidarPago(withValidarRecuperar(ContainerPagoTBTA));
export default withValidarPago(ContainerPagoTBTA);

const ItemDetalle = ({ label, value }) => {
  return (
    <React.Fragment>
      <div>
        <h4 className="d-inline">{label} </h4>
        <p className="d-inline font-source-sans-regular" style={{ fontSize: '20px' }}>
          {value}
        </p>
      </div>
    </React.Fragment>
  );
};
